const colors = {
  black: '#000000',
  white: '#FFFFFF',
  overlay: 'rgba(99, 115, 129, 0.25)',
  gray: {
    50: '#F8F8F8',
    100: '#F1F2F3',
    200: '#DFE3E8',
    400: '#637381',
    500: '#59595E',
    800: '#3C3C3F',
  },
  danger: '#FF002E',
  success: '#38A169',
  warning: '#DD6B20',
  stepper: {
    stepCounter: {
      background: {
        complete: '#212b36',
        incomplete: '#dfe3e8',
      },
      color: {
        complete: '#dfe3e8',
        incomplete: '#212b36',
      },
    },
    stepperItem: {
      stepperLine: {
        complete: '#212b36',
        incomplete: '#dfe3e8',
      },
    },
    label: {
      color: '#000000',
    },
  },
  progressBar: {
    progressBarItem: {
      background: {
        complete: '212b36',
        incomplete: '#f1f2f3',
      },
    },
    productCountLabel: {
      color: {
        incomplete: 'white',
        complete: 'black',
      },
    },
  },
};

export default colors;
